import { AutogenModelEdiLog, AutogenRowEdiLog } from "./autogen/AutogenModelEdiLog";

export class ModelEdiLog extends AutogenModelEdiLog<RowEdiLog> {
    constructor() {
        super(RowEdiLog);
    }
}

export class RowEdiLog extends AutogenRowEdiLog {
}